import {
  NOTIFICATION_DETAIL,
  NOTIFICATION_DETAIL_FAIL,
  NOTIFICATION_DETAIL_RESET,
  NOTIFICATION_DETAIL_SUCCESS,
  NOTIFICATION_HEADER_LIST,
  NOTIFICATION_HEADER_LIST_FAIL,
  NOTIFICATION_HEADER_LIST_RESET,
  NOTIFICATION_HEADER_LIST_SUCCESS,
  NOTIFICATION_LIST,
  NOTIFICATION_LIST_COLUMN,
  NOTIFICATION_LIST_FAIL,
  NOTIFICATION_LIST_RESET,
  NOTIFICATION_LIST_SUCCESS,
} from "./actionTypes";

const INIT_STATE = {
  // List Notification
  list: {
    items: [],
    totalCount: 0,
    columnsVisible: null,
    params: {
      sizePerPage: 10,
      page: 1,
      sort: "-maker_date",
      columnFilter: {}, // Column filter
      keywords: "", // Input search all
    },
  },
  loadingList: false,
  errorList: null,

  // List Notification Header
  listHeader: {
    items: [],
    params: {
      limit: 10,
    },
  },
  loadingListHeader: false,
  errorListHeader: null,

  // Detail Notification
  detail: null,
  loadingDetail: false,
  errorDetail: null,
};

const notificationManagement = (state = INIT_STATE, action) => {
  switch (action.type) {
    // List Notification
    case NOTIFICATION_LIST:
      return {
        ...state,
        loadingList: true,
        errorList: null,
      };
    case NOTIFICATION_LIST_SUCCESS:
      return {
        ...state,
        loadingList: false,
        errorList: null,
        list: {
          ...state.list,
          items: action.payload.items,
          totalCount: action.payload._meta
            ? action.payload._meta.totalCount
            : action.payload.items.length,
          success: true,
        },
      };
    case NOTIFICATION_LIST_FAIL:
      return { ...state, loadingList: false, errorList: action.payload };
    case NOTIFICATION_LIST_RESET:
      return {
        ...state,
        loadingList: false,
        errorList: null,
        list: {
          ...state.list, // columnsVisible
          items: [],
          totalCount: 0,
          params: {
            sizePerPage: 10,
            page: 1,
            sort: "-maker_date",
            columnFilter: {},
            keywords: "",
          },
        },
      };
    case NOTIFICATION_LIST_COLUMN:
      const currentColumns = state.list.columnsVisible || {};
      currentColumns[action.payload.field] = action.payload.value;
      return {
        ...state,
        list: { ...state.list, columnsVisible: currentColumns },
      };

    // List Notification Header
    case NOTIFICATION_HEADER_LIST:
      return {
        ...state,
        loadingListHeader: true,
        errorListHeader: null,
      };
    case NOTIFICATION_HEADER_LIST_SUCCESS:
      return {
        ...state,
        loadingListHeader: false,
        errorListHeader: null,
        listHeader: {
          ...state.listHeader,
          items: action.payload || [],
          success: true,
        },
      };
    case NOTIFICATION_HEADER_LIST_FAIL:
      return {
        ...state,
        loadingListHeader: false,
        errorListHeader: action.payload,
      };
    case NOTIFICATION_HEADER_LIST_RESET:
      return {
        ...state,
        loadingListHeader: false,
        errorListHeader: null,
        listHeader: {
          items: [],
          params: {
            limit: 10,
          },
        },
      };

    // Detail Notification
    case NOTIFICATION_DETAIL:
      return {
        ...state,
        loadingDetail: true,
        errorDetail: null,
      };
    case NOTIFICATION_DETAIL_SUCCESS:
      return {
        ...state,
        loadingDetail: false,
        errorDetail: null,
        detail: { ...action.payload, success: true },
      };
    case NOTIFICATION_DETAIL_FAIL:
      return { ...state, loadingDetail: false, errorDetail: action.payload };
    case NOTIFICATION_DETAIL_RESET:
      return {
        ...state,
        loadingDetail: false,
        errorDetail: null,
        detail: null,
      };

    default:
      return state;
  }
};

export default notificationManagement;
